/** @jsx jsx */
import { createContext, useContext } from "react"

import { jsx } from "@trueskin-web/theme"

const PageContext = createContext()

const PageProvider = ({ isExternal, ...props }) => {
  const value = {
    isExternal,
  }
  return <PageContext.Provider value={value} {...props} />
}

const usePageContext = () => useContext(PageContext)

export { PageProvider, usePageContext }
